import React from "react";

interface SVGIconProps {
  iconname?: string;
  width?: number;
  height?: number;
  fill?: string;
  strokeWidth?: number | string;
}

/** Minimal SVG icon set used by SelectField. */
export default function SVGIcon({
  iconname,
  width = 20,
  height,
  fill = "currentColor",
  strokeWidth = 1.5,
}: SVGIconProps) {
  const h = height || width;
  const common: React.SVGProps<SVGSVGElement> = {
    width,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: fill,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  if (iconname === "close-icon") {
    return (
      <svg {...common}>
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    );
  }
  if (iconname === "top-arrow-icon") {
    return (
      <svg {...common}>
        <path d="M6 15l6-6 6 6" />
      </svg>
    );
  }
  if (iconname === "bottom-arrow-icon") {
    return (
      <svg {...common}>
        <path d="M6 9l6 6 6-6" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <circle cx="12" cy="12" r="4" />
    </svg>
  );
}
